import PropTypes from "prop-types"
import React from "react"
import { useFormContext } from "react-hook-form"

import Form from "src/components/Form"
import HeadingSectionHeader from "src/components/Heading/HeadingSectionHeader"

import { capitalize } from "src/utils/string_helpers"

const FuelMeasurementUnitSelector = ({
  fuelMeasurementUnitSettingsEnabled,
  fuelMeasurementUnits,
}) => {
  const { register } = useFormContext()

  if (!fuelMeasurementUnitSettingsEnabled) return null

  return (
    <div className="mb-6 grid grid-cols-12">
      <div className="col-span-12">
        <HeadingSectionHeader>Fuel Measurement Unit</HeadingSectionHeader>
      </div>
      <div className="col-span-12 mt-4 flex flex-col px-2 sm:col-span-6">
        <Form.Label htmlFor="fuelMeasurementUnit">Unit</Form.Label>
        <Form.Select
          {...register("fuelMeasurementUnit")}
          id="fuelMeasurementUnit"
        >
          {fuelMeasurementUnits.map((unit) => (
            <option key={unit} value={unit}>
              {capitalize(unit)}
            </option>
          ))}
        </Form.Select>
      </div>
    </div>
  )
}

FuelMeasurementUnitSelector.propTypes = {
  fuelMeasurementUnitSettingsEnabled: PropTypes.bool.isRequired,
  fuelMeasurementUnits: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default FuelMeasurementUnitSelector
